<script setup>
import { computed } from 'vue';
import { Link } from '@inertiajs/vue3';

const props = defineProps({
    /** A navigation entry: `{ title, permalink, is_external, is_current }`. */
    item: {
        type: Object,
        required: true,
    },
});

/** External entries must not be routed through Inertia. */
const component = computed(() => (props.item.is_external ? 'a' : Link));
</script>

<template>
    <Component
        :is="component"
        :href="item.permalink"
        :target="item.is_external ? '_blank' : null"
        :rel="item.is_external ? 'noopener noreferrer' : null"
        :aria-current="item.is_current ? 'page' : null"
    >
        <slot>{{ item.title }}</slot>
    </Component>
</template>
